import { HEALTHCARE_COURSE_DAILY_PRICES, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import CreateHealthcareCourseDailyPrice from "./Create";
import ListHealthcareCourseDailyPrices from "./List";

export const resources = {
  isMenu: false,
  name: SpecialistServicePath + HEALTHCARE_COURSE_DAILY_PRICES,
  title: "Дневни такси курсове за здравни грижи",
  list: <ListHealthcareCourseDailyPrices />,
  create: <CreateHealthcareCourseDailyPrice />,
  createPermission: permissions.canManageHealthcareCourseDailyPrices,
  permission: permissions.canPreviewHealthcareCourseDailyPrices,
};
